<template>
  <Promised :promise="usersPromise">
    <template v-slot:pending>
      <p>Загрузка...</p>
    </template>
    <template v-slot="data">
      {{ data?.name ?? data }}
    </template>
    <template v-slot:rejected="error">
      <p>Error: {{ error.message }}</p>
    </template>
  </Promised>
</template>

<script>
import {Promised, usePromise} from 'vue-promised'

export default {
  props: ['id'],
  components: {
    Promised,
    usePromise,
  },
  data() {
    return {
      usersPromise: null
    }
  },
  created() {
    if (this.id) this.usersPromise = this.getUserData(this.id);
  },
}
</script>
